import { createStore } from 'redux'

// Rehydrate the admin session from localStorage *synchronously* so the very
// first render of the app already has the user loaded. Without this, a hard
// refresh on a protected route briefly evaluates `adminDetails` as null and
// the route guard kicks the user back to /login before redux can catch up.
const rehydrateAdmin = () => {
  try {
    const raw = localStorage.getItem('sparrowSignIn');
    if (!raw) return null;
    const payload = JSON.parse(raw);
    if (!payload?.token || !payload?.user) return null;
    const u = payload.user;
    return {
      id: u.id,
      token: payload.token,
      fireBase_token: u.fcm_token,
      first_name: u.first_name,
      last_name: u.last_name,
      email: u.email,
      image: u.image,
    };
  } catch {
    // Corrupted JSON in localStorage shouldn't take the whole app down —
    // treat it as logged-out and let the user sign in again.
    return null;
  }
};

const initialState = {
  sidebarShow: true,
  // `null` when signed out, an object once a session is present. Consumers
  // already use optional chaining, so this is a safer shape than `[]`.
  adminDetails: rehydrateAdmin(),
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'setAdmin':
        return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
